// DropdownButton.tsx
import * as React from 'react';
import Button, { ButtonProps } from '@minecraft.button';
import { BaseDropdownButton } from './BaseDropdownButton';
import { DropdownItemProps, OptionalProps } from './types';

export interface DropdownButtonProps extends OptionalProps {
  toggleLabel: React.ReactNode;
  toggleProps: Partial<Omit<ButtonProps, 'children' | 'qaId' | 'testId'>>;
  menuItemsProps: DropdownItemProps[];
  menuChildren?: React.ReactNode;
  menuAlign?: 'right' | 'left';
  block?: boolean;
  mobileBlock?: boolean;
  disabled?: boolean;
  showCaret?: boolean;
}

export const DropdownButton = ({
  toggleProps = {},
  toggleLabel,
  menuAlign = 'right',
  menuItemsProps = [],
  menuChildren,
  block = false,
  mobileBlock = false,
  'data-testid': dataTestId,
  qaId,
  className,
  disabled = false,
  showCaret = true,
}: DropdownButtonProps) => (
  <BaseDropdownButton
    block={block}
    className={className}
    data-testid={dataTestId}
    menuAlign={menuAlign}
    menuItemsProps={menuItemsProps}
    menuChildren={menuChildren}
    mobileBlock={mobileBlock}
    qaId={qaId}
    showCaret={showCaret}
    toggleChildren={toggleLabel}
    ToggleComponent={Button}
    toggleProps={{ ...toggleProps, disabled: toggleProps.disabled || disabled, fixedWidth: false }}
  />
);
